import React, {Component} from 'react';

var CONTACTME = 3;
var EXTERNALURL = 1;
var NO_ACTION = 0;
const style2 = {
	width : "150px",
	margin : "auto",
	textAlign: 'center',
}
class SatisfactionMeter extends Component{
	constructor(props){
		super(props);
		this.state = {
			type:0,
			error: false,
			feedback: {},
			contactOption: "Email",
			contactBy: "",
			isSent: false
		}
	}
	componentDidMount = () =>{
		var fingerprint = this.randomID();
		let url = `${process.env.PUBLIC_URL}${this.props.wspace}${process.env.ORIGIN_PATH}`
		$.get( url + this.props.url+"/"+fingerprint)
		.then((rs) =>{
			this.setState({error: false, type: rs.type, feedback: rs});
		})
		.fail((err)=>{
			this.setState({error: true});
		});
	}
	randomID = () =>{
		return Math.random().toString(36).substr(2, 9);
	}
	save = () =>{
		this.setState({isSent: true});
		let feedback = this.state.feedback;
		var fingerprint = this.randomID();
		var answerLink = `${process.env.PUBLIC_URL}${this.props.wspace}${process.env.ORIGIN_PATH}`;
		if (this.props.preview) return;
		if (!answerLink.endsWith('/')) answerLink += '/';
		answerLink += 'satisfaction/meter/contact/success';
		$.post(answerLink,{
			feedbackSettingId: feedback.feedbackSettingId,
			errand: feedback.errandId,
			question: feedback.question,
			answer:feedback.answer,
			feedback: feedback.currentFeedback,
			contactBy: this.state.contactOption,
			value: this.state.contactBy,
			contactErrandArea: feedback.area,
			userUniqueId: fingerprint
		})
		.done(rs =>{
			console.log("Saved");
		})
		.fail(()=>{
			alert(I("Feedback was not saved."));
		});
	}
	handleSelect = ( event )=>{
		this.setState({contactOption: event.target.value});
	}
	handleInputChange = ( event )=>{
		this.setState({contactBy: event.target.value});
	}
	render = () =>{
		let sm = {
			textAlign: 'center',
			margin: '5px',
			border: '1px solid #ddd',
		}
		let overflow = {
			overflow: 'auto'
		}
		let s = this.state;
		if(s.error){
			return(<div style={sm}>{I("Satisfaction feedback wasn't saved, please contact Cention Support.")}</div>)
		}
		if(this.state.isSent){
			return(<div id="wrapper">
					<div id="page-wrapper">
						<div className="row">
							<div className="col-lg-6">
								<div className="panel">
										<div style={sm}>{I("Contact sent")}</div>
								</div>
							</div>
						</div>
					</div>
			</div>)
		}
		let contactMe = "";
		if(s.type === NO_ACTION && s.feedback.registered == false){
			window.close();
		} else if(s.type === CONTACTME && s.feedback.registered == false ){
			contactMe = <div className="panel-body">
					<div className="form-group" style={overflow}>
						<label className="col-lg-3 col-sm-1">{I("Choose option")}</label>
						<div className="col-lg-5 col-sm-4">
							<select name="contactOption" value={s.contactOption} onChange={this.handleSelect} className="form-control input-sm">
								<option key={1} value={"Email"}>{"Email"}</option>
								<option key={2} value={"Phone"}>{"Phone"}</option>
							</select>
						</div>
					</div>
					<div className="form-group" style={overflow}>
						<label className="col-lg-3 col-sm-1">{I("Contact by")}:<span className="mandatory">* </span></label>
						<div className="col-lg-5 col-sm-4">
							<input name="contactBy" className="form-control input-sm" type="text" onChange={this.handleInputChange} />
						</div>
					</div>
					<div className="form-group">
						<div className="col-lg-6 textAlignRight">
							<button className="btn btn-primary btn-sm" type="button" onClick={this.save}>{L('Save')}</button>
						</div>
					</div>
				</div>
		} else if(s.type == EXTERNALURL && s.feedback.registered == false){
			let redirectTo = "about:blank";
			if(typeof s.feedback.externalUrl !== 'undefined' &&
					s.feedback.externalUrl != ""){
				redirectTo = s.feedback.externalUrl;
			}
			window.location.href = redirectTo;
		}
		let feedbackMessage  = (<div style={sm} dangerouslySetInnerHTML={{__html: s.feedback.message}}></div>);
		if(typeof s.feedback.uploadType !== 'undefined' &&
				s.feedback.uploadType == 1){
			feedbackMessage = (
				<div>
			<div id="feedback_template_preview_content" dangerouslySetInnerHTML={{__html: s.feedback.message}}/>
				</div>
			);
		} else if(typeof s.feedback.imageTop !== 'undefined'){
			var style = {
				maxWidth: "140px",
				maxHeight: "140px",
				minWidth: "50px",
				minheight: "50px",
				margin: "5px"
			};
			if(s.feedback.imagePath === null || !s.feedback.imagePath
				 || s.feedback.imagePath.endsWith("/")
				 || s.feedback.imagePath.indexOf("feedbackimage//") != -1 ){
				feedbackMessage = (
				<div>
					<div style={sm} dangerouslySetInnerHTML={{__html: s.feedback.message}}></div>
				</div>);
			} else if(s.feedback.imageTop == true){
				feedbackMessage = (
				<div style={{'textAlign':'center;'}}>
					<div style= {style2}>
						 <img style={style} width = "140px" src={s.feedback.imagePath}/>
					</div>
					<div style={sm} dangerouslySetInnerHTML={{__html: s.feedback.message}}></div>
				</div>);
			} else {
				feedbackMessage = (
				<div>
					<div style={sm} dangerouslySetInnerHTML={{__html: s.feedback.message}}></div>
					<div>
						 <img style={style} src={s.feedback.imagePath}/>
					</div>
				</div>);
			}
		}
		return(<div id="wrapper">
				<div id="page-wrapper">
					<div className="row">
						<div className="col-lg-12">
							<div className="panel">
								{feedbackMessage}
								{contactMe}
							</div>
						</div>
					</div>
				</div>
		</div>)
	}
}
export default SatisfactionMeter;
